// extracted by mini-css-extract-plugin
module.exports = {"Personal":"__4ifrF1Jh","btn":"xsc5l_zN","popup":"B9Igkfzi","wrap":"Nf8xBFGw","container":"Iu1aAvGH","ic":"E0k3q4Fi"};